import React, { ReactElement } from 'react'
import { useGetProvisionQuery } from 'store/api/provision'
import ProvisionTable from './ProvisionTable'

export default function ProvisionContent(): ReactElement {
  const { data: provisionData } = useGetProvisionQuery('')

  return <ProvisionTable provisions={provisionData?.provisions || []} />
}
